<template>
  <el-dialog class="tips" title="Tips" :visible.sync="visible" @close="close()" width="600px">
    <p>Your information is under review</p>
    <div class="footer" slot="footer">
      <el-button type="button" @click="close()">Close</el-button>
    </div>
  </el-dialog>
</template>

<script>
import store from '../vuex/store'

export default {
  data() {
    return {
      visible: this.show,
    }
  },
  watch: {
    show(newValue) {
      this.visible = this.show
    },
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      store.commit('TIP_SHOW', false)
    },
  },
}
</script>

<style lang="scss">
.tips {
  p {
    margin: 15px 0;
    font-size: 20px;
  }
}
</style>
